import { format } from 'date-fns'
import { makeObservable, observable } from 'mobx'
import React from 'react'

class ResponseRateStore {
    constructor(store) {
        makeObservable(this)
        this.store = store
    }

    @observable respondentTypes = [{ label: 'All', value: 'all' }]

    @observable surveyTypes = []

    productMap = []

    respondentTypesFilter = []

    @observable isResultFetchedOnce = false

    @observable pending = false

    @observable responseRateRequest = {
        surveyType: 'all',
        respondentType: ['all'],
        startDate: null,
        endDate: null,
    }

    @observable response = {
        closedSurveys: '',
        completions: '',
        uniqueEmails: '',
        responseRate: '',
        surveys: [],
    }

    columns = [
        {
            name: 'Client ID',
            key: 'clientId',
        },
        {
            name: 'Survey Name',
            key: 'surveyName',
        },
        {
            name: 'Product Name',
            key: 'productName',
        },
        {
            name: 'Respondent Type',
            key: 'respondentType',
            dataTransform: (respondentType) => (
                <p>
                    {this.getRespondent(respondentType)}
                </p>
            ),
        },
        {
            name: 'Survey Id',
            key: 'surveyId',
        },
        {
            name: 'Completed Responses',
            key: 'completions',
        },
        {
            name: 'Unique Emails',
            key: 'uniqueEmails',
        },
        {
            name: 'Response Rate',
            key: 'responseRate',
            dataTransform: (responseRate) => (
                <p>
                    {(responseRate * 100).toFixed(2)}
                    {' '}
                    %
                </p>
            ),
        },
    ]

    getRespondent = (code) => {
        const respondent = this.respondentTypesFilter.filter((element) => (element.value === code))
            .map((item) => (item.label))
        return respondent[0]
    }

    getOptions = async () => {
        this.productMap = await this.store.http.get('/productmap')
        this.setOptions()
    }

    setOptions = () => {
        const prodMap = {
            surveyTypes: { all: { label: 'ALL', value: 'all' } },
            respondentTypes: {},
        }

        this.productMap.forEach((map) => {
            if (!prodMap.surveyTypes[map.surveytypecode]) {
                prodMap.surveyTypes[map.surveytypecode] = {
                    label: map.surveytypename,
                    value: map.surveytypecode,
                }
            }
            if (!prodMap.respondentTypes[map.respondenttypecode]) {
                prodMap.respondentTypes[map.respondenttypecode] = {
                    label: `${map.industryname} - ${map.respondenttypename}`,
                    value: map.respondenttypecode,
                    surveyTypes: new Set([map.surveytypecode]),
                }
            } else {
                prodMap.respondentTypes[map.respondenttypecode]
                    .surveyTypes.add(map.surveytypecode)
            }
        })
        this.surveyTypes = Object.keys(prodMap.surveyTypes)
            .map((key) => (prodMap.surveyTypes[key]))
        this.respondentTypesFilter = Object.keys(prodMap.respondentTypes)
            .map((key) => (prodMap.respondentTypes[key]))
    }

    setRespondentTypeOptions = () => {
        this.responseRateRequest.respondentType = []
        if (this.responseRateRequest.surveyType === 'all') {
            this.respondentTypes = this.respondentTypesFilter
            this.respondentTypes.unshift({ label: 'All', value: 'all' })
            return
        }
        this.respondentTypes = this.respondentTypesFilter
            .filter((respo) => (respo.surveyTypes
                && respo.surveyTypes.has(this.responseRateRequest.surveyType)))
        this.respondentTypes.unshift({ label: 'All', value: 'all' })
    }

    handleChangeRequest = ({ value }, propertyName) => {
        switch (propertyName) {
            case 'startDate':
                this.responseRateRequest.startDate = value.format('YYYY-MM-DD')
                break
            case 'endDate':
                this.responseRateRequest.endDate = value.format('YYYY-MM-DD')
                break
            case 'surveyType':
                this.responseRateRequest.surveyType = value
                this.setRespondentTypeOptions()
                break
            case 'respondentType':
                this.responseRateRequest.respondentType = value.map(
                    (respondent) => respondent.value,
                )
                break
            default: this.responseRateRequest = {
                surveyType: '',
                respondentType: [],
                startDate: null,
                endDate: null,
            }
        }
    }

    validateDateSelection = () => {
        if (!this.responseRateRequest.startDate) {
            throw new Error('Insert a Starting Date')
        } else if (!this.responseRateRequest.endDate) {
            throw new Error('Insert a End Date')
        }
    }

    customizeRequest = (req) => {
        const request = { ...req }

        if (request.surveyType === 'all') {
            delete request.surveyType
        }
        if (request.respondentType.includes('all')) {
            request.respondentType = []
        }

        return request
    }

    getSystemResposeRate = async () => {
        try {
            this.pending = true
            const request = this.customizeRequest(this.responseRateRequest)
            this.validateDateSelection()
            this.response = await this.store.http.post('/intranet/systemResponseRates', JSON.stringify(request))
            this.pending = false
            this.isResultFetchedOnce = true
        } catch (e) {
            this.pending = false
            this.store.handleError({ body: `something went wrong: ${e.message}`, level: 'error' })
        }
    }
}
export default ResponseRateStore
